/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-14 09:38:50
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\management\tableConfig.js
*/
import config from '@/config/config';

const screenOperationConf = [1,];

const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '主矿种',
    dataIndex: 'primaryCommodity',
    slots: { customRender: 'primaryCommodity', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目名称',
    dataIndex: 'propName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国家',
    dataIndex: 'countryName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '省份',
    dataIndex: 'stateProvince',
    ellipsis: true,
    align: 'center',
    width: 100,
  },
  {
    title: '全部矿种',
    dataIndex: 'commoditiesList',
    slots: { customRender: 'commoditiesList', },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '矿权类型',
    dataIndex: 'claimType',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '开发阶段',
    dataIndex: 'devStage',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '运营商',
    dataIndex: 'operatorName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '曾用名',
    dataIndex: 'usedName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width:  240 ,
  },
];

export default tableConfig;
